import gql from 'graphql-tag';
import { useState, useContext, useEffect } from 'react';
import { AccountContext } from '../components/AccountContext';
import { useQuery } from '@apollo/react-hooks';
import { isAccountOfNewBusinessModelType } from '../utils/AppUtil';

const CHECK_SUBSCRIPTION_QUERY = gql`
  query checkSubscriptionQuery($accountId: ID!) {
    account(id: $accountId) {
      id
      type
      isHeadOfFamily
      subscriptionInformation {
        hasActiveSubscription
        currentSubscription {
          endsOn
        }
      }
    }
  }
`;

const DEFAULT_ACCOUNT_STATE = {
  id: null,
  type: null,
  isHeadOfFamily: false,
  subscriptionInformation: {
    hasActiveSubscription: false,
    currentSubscription: {
      endsOn: null,
    },
  },
};

const useSubscriptionExpiredRestrictions = () => {
  const [account, setAccount] = useState(DEFAULT_ACCOUNT_STATE);

  const currentAccount = useContext(AccountContext);

  const { data } = useQuery(CHECK_SUBSCRIPTION_QUERY, { variables: { accountId: currentAccount } });

  const { account: accountFromQuery } = data;

  useEffect(() => {
    if (accountFromQuery) {
      setAccount(accountFromQuery);
    }
  }, [currentAccount, accountFromQuery]);

  const isAccountSubscriptionExpired = () => {
    const { type, isHeadOfFamily, subscriptionInformation } = account;

    const isNewBusinessModelAccount = isAccountOfNewBusinessModelType(type);

    if (!isNewBusinessModelAccount) return false;

    if (!isHeadOfFamily) return false;

    if (!subscriptionInformation) return true;

    const { hasActiveSubscription, currentSubscription } = subscriptionInformation;

    if (!hasActiveSubscription || !currentSubscription) return true;

    const { endsOn } = currentSubscription;

    return new Date() > new Date(endsOn);
  };

  const subscriptionIsExpired = isAccountSubscriptionExpired();

  return {
    subscriptionIsExpired,
  };
};

export default useSubscriptionExpiredRestrictions;
